import * as React from "react";

import { TableCell, TableRow } from "../table";
import { cn } from "../utils";

interface EmptyTableRowProps {
  colSpan: number;
  children: React.ReactNode;
  className?: string;
}

/**
 * Standard empty-state row for tables. Uses `text-muted-foreground` per the
 * project's typography rules; consumers should not override the color to
 * `text-foreground` (which was the pre-consolidation drift).
 */
export function EmptyTableRow({
  colSpan,
  children,
  className,
}: EmptyTableRowProps) {
  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        className={cn(
          "text-center text-muted-foreground py-8 type-body whitespace-normal",
          className,
        )}
      >
        {children}
      </TableCell>
    </TableRow>
  );
}
